import { render, staticRenderFns } from "./IframeWithBar.vue?vue&type=template&id=650e744a&"
import script from "./IframeWithBar.vue?vue&type=script&lang=js&"
export * from "./IframeWithBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports